import type { FunctionComponent } from 'react';
import { getSaleType } from '../../../utils/orders';
import Products from '../Products';
import ShipmentHeader from '../ShipmentHeader';
import * as styles from './styles.module.scss';

type Shipment = {
  shipmentDetails: { carrier?: string; trackingNumber?: string };
  products: {
    productType: string;
    items: {
      name: string;
      brandName: string;
      priceInCents: number;
      quantity: number;
      imageUrl: string;
      autoAssigned: boolean;
      slug: string;
    }[];
  }[];
};

type DesktopProductListProps = {
  shipped: Shipment[];
  pending: Shipment[];
  dropship: Shipment[];
  trackShipment: () => void;
};

const DesktopProductList: FunctionComponent<DesktopProductListProps> = ({
  shipped,
  pending,
  dropship,
  trackShipment,
}) => (
  <section className={styles.productList} data-testid="desktop-items">
    {shipped.map((shipment, index) => (
      <div key={index} className={styles.shipment}>
        <ShipmentHeader
          title={`Shipment ${index + 1}`}
          subtitle={getSaleType(shipment)}
          shipmentDetails={shipment.shipmentDetails}
          trackShipment={trackShipment}
        />
        <Products products={shipment.products} />
      </div>
    ))}
    {pending.map((shipment, index) => (
      <div key={index} className={styles.shipment}>
        <ShipmentHeader
          title="Pending Shipment"
          subtitle={getSaleType(shipment)}
          shipmentDetails={shipment.shipmentDetails}
          trackShipment={trackShipment}
        />
        <Products products={shipment.products} />
      </div>
    ))}
    {dropship.map((shipment, index) => (
      <div key={index} className={styles.shipment}>
        <ShipmentHeader
          title="Drop Ship"
          subtitle={getSaleType(shipment)}
          shipmentDetails={shipment.shipmentDetails}
          trackShipment={trackShipment}
        />
        <Products products={shipment.products} />
      </div>
    ))}
  </section>
);

export default DesktopProductList;
